import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetPlannings, useGetYard } from '@/api/generated';
import { formatDateForDisplay } from '@/lib/utils';

interface SelectedSourcesSummaryProps {
  yardId: string;
  planningId: string;
}

/** Reads the step 1 queries from cache to name what the planning step edits. */
const SelectedSourcesSummary: FC<SelectedSourcesSummaryProps> = ({
  yardId,
  planningId,
}) => {
  const { t } = useTranslation();
  const { data: yard } = useGetYard(yardId);
  const { data: plannings } = useGetPlannings({ skip: 0, limit: 15 });
  const planning = plannings?.items.find((item) => item.id === planningId);

  return (
    <p className='text-sm text-muted-foreground'>
      {t('scenarios.create.sourcesSummary', {
        yard: yard?.filename ?? '…',
        date: formatDateForDisplay(planning?.upload_timestamp),
      })}
    </p>
  );
};

export default SelectedSourcesSummary;
